import { NavigateFunction } from "react-router-dom";
import { savaquanFetchJson } from "./http.service";
import { CompanyPricingRulesDto, UpdateCompanyPricingRulesDto } from "../dtos/company-pricing-rules.dto";

const baseUrl = `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/company-settings/pricing-rules`;

/** SQ-283: the company's job pricing rules; every rule off until something is saved. */
export async function getPricingRules(navigate: NavigateFunction): Promise<CompanyPricingRulesDto> {
  return savaquanFetchJson<CompanyPricingRulesDto>(baseUrl, { navigate });
}

export async function savePricingRules(navigate: NavigateFunction, rules: UpdateCompanyPricingRulesDto): Promise<CompanyPricingRulesDto> {
  return savaquanFetchJson<CompanyPricingRulesDto>(baseUrl, {
    navigate,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(rules),
  });
}
